/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfGetFormBuilderFieldByIdDto } from '../models/custom-result-of-get-form-builder-field-by-id-dto';
import { CustomResultOfListOfGetFormBuilderFieldsListDto } from '../models/custom-result-of-list-of-get-form-builder-fields-list-dto';
import { CustomResultOfPaginatedListOfGetFormBuilderFieldWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-form-builder-field-with-pagination-dto';
import { formBuilderFieldsCreate } from '../fn/form-builder-fields/form-builder-fields-create';
import { FormBuilderFieldsCreate$Params } from '../fn/form-builder-fields/form-builder-fields-create';
import { formBuilderFieldsDelete } from '../fn/form-builder-fields/form-builder-fields-delete';
import { FormBuilderFieldsDelete$Params } from '../fn/form-builder-fields/form-builder-fields-delete';
import { formBuilderFieldsGetFormBuilderFieldsList } from '../fn/form-builder-fields/form-builder-fields-get-form-builder-fields-list';
import { FormBuilderFieldsGetFormBuilderFieldsList$Params } from '../fn/form-builder-fields/form-builder-fields-get-form-builder-fields-list';
import { formBuilderFieldsGetFormBuilderFieldsWithPagination } from '../fn/form-builder-fields/form-builder-fields-get-form-builder-fields-with-pagination';
import { FormBuilderFieldsGetFormBuilderFieldsWithPagination$Params } from '../fn/form-builder-fields/form-builder-fields-get-form-builder-fields-with-pagination';
import { formBuilderFieldsUpdateGet } from '../fn/form-builder-fields/form-builder-fields-update-get';
import { FormBuilderFieldsUpdateGet$Params } from '../fn/form-builder-fields/form-builder-fields-update-get';
import { formBuilderFieldsUpdatePut } from '../fn/form-builder-fields/form-builder-fields-update-put';
import { FormBuilderFieldsUpdatePut$Params } from '../fn/form-builder-fields/form-builder-fields-update-put';

@Injectable({ providedIn: 'root' })
export class FormBuilderFieldsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formBuilderFieldsCreate()` */
  static readonly FormBuilderFieldsCreatePath = '/FormBuilderFields/Create';

  /**
   * ایجاد فیلد جدید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuilderFieldsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsCreate$Response(params: FormBuilderFieldsCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return formBuilderFieldsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * ایجاد فیلد جدید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuilderFieldsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsCreate(params: FormBuilderFieldsCreate$Params, context?: HttpContext): Observable<CustomResult> {
    return this.formBuilderFieldsCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `formBuilderFieldsUpdateGet()` */
  static readonly FormBuilderFieldsUpdateGetPath = '/FormBuilderFields/Update';

  /**
   * دریافت فیلد بر اساس شناسه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuilderFieldsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuilderFieldsUpdateGet$Response(params?: FormBuilderFieldsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetFormBuilderFieldByIdDto>> {
    return formBuilderFieldsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت فیلد بر اساس شناسه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuilderFieldsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuilderFieldsUpdateGet(params?: FormBuilderFieldsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetFormBuilderFieldByIdDto> {
    return this.formBuilderFieldsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetFormBuilderFieldByIdDto>): CustomResultOfGetFormBuilderFieldByIdDto => r.body)
    );
  }

  /** Path part for operation `formBuilderFieldsUpdatePut()` */
  static readonly FormBuilderFieldsUpdatePutPath = '/FormBuilderFields/Update';

  /**
   * ویرایش فیلد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuilderFieldsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsUpdatePut$Response(params: FormBuilderFieldsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return formBuilderFieldsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش فیلد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuilderFieldsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsUpdatePut(params: FormBuilderFieldsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.formBuilderFieldsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `formBuilderFieldsDelete()` */
  static readonly FormBuilderFieldsDeletePath = '/FormBuilderFields/Delete';

  /**
   * حذف فیلد.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuilderFieldsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsDelete$Response(params: FormBuilderFieldsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return formBuilderFieldsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف فیلد.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuilderFieldsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsDelete(params: FormBuilderFieldsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.formBuilderFieldsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `formBuilderFieldsGetFormBuilderFieldsWithPagination()` */
  static readonly FormBuilderFieldsGetFormBuilderFieldsWithPaginationPath = '/FormBuilderFields/GetFormBuilderFieldsWithPagination';

  /**
   * دریافت فیلدهای سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuilderFieldsGetFormBuilderFieldsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsGetFormBuilderFieldsWithPagination$Response(params: FormBuilderFieldsGetFormBuilderFieldsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetFormBuilderFieldWithPaginationDto>> {
    return formBuilderFieldsGetFormBuilderFieldsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت فیلدهای سازمان با صفحه بندی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuilderFieldsGetFormBuilderFieldsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  formBuilderFieldsGetFormBuilderFieldsWithPagination(params: FormBuilderFieldsGetFormBuilderFieldsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetFormBuilderFieldWithPaginationDto> {
    return this.formBuilderFieldsGetFormBuilderFieldsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetFormBuilderFieldWithPaginationDto>): CustomResultOfPaginatedListOfGetFormBuilderFieldWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `formBuilderFieldsGetFormBuilderFieldsList()` */
  static readonly FormBuilderFieldsGetFormBuilderFieldsListPath = '/FormBuilderFields/GetFormBuilderFieldsList';

  /**
   * دریافت لیست فیلدهای سازمان.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `formBuilderFieldsGetFormBuilderFieldsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuilderFieldsGetFormBuilderFieldsList$Response(params?: FormBuilderFieldsGetFormBuilderFieldsList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetFormBuilderFieldsListDto>> {
    return formBuilderFieldsGetFormBuilderFieldsList(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست فیلدهای سازمان.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `formBuilderFieldsGetFormBuilderFieldsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  formBuilderFieldsGetFormBuilderFieldsList(params?: FormBuilderFieldsGetFormBuilderFieldsList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetFormBuilderFieldsListDto> {
    return this.formBuilderFieldsGetFormBuilderFieldsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetFormBuilderFieldsListDto>): CustomResultOfListOfGetFormBuilderFieldsListDto => r.body)
    );
  }

}
